import * as React from "react";
const SvgEmail = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.871 3.754V20.256H22.13V3.754H12ZM3.38 5.252H20.62v1.637l-4.31 2.586c-3.476 2.085-4.316 2.584-4.329 2.576-.008-.006-1.947-1.17-4.308-2.586L3.379 6.89v-.82Zm0 3.389 4.31 2.586L12 13.812l4.31-2.585 4.311-2.586v10.107H3.38v-5.053z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgEmail;
